export const LINEWIDTH = {
  SMALL: 2,
  MEDIUM: 5,
  LARGE: 8,
};

export const MODE = {
  FREEHAND: 'freehand',
  ELLIPSE: 'ellipse',
  RECTANGLE: 'rectangle',
  ARROW: 'arrow',
  PAN: 'pan',
  ERASE: 'erase',
  SELECT: 'select',
};

export const PALETTE_LIGHT = [
  '#fd5865', // red
  '#ff8e52', // orange
  '#feb849', // yellow
  '#1fc370', // green
  '#2e9ceb', // blue
  '#959595', // gray
  '#000000', // black
];

export const PALETTE_DARK = [
  '#fd5865', // red
  '#ff8e52', // orange
  '#feb849', // yellow
  '#1fc370', // green
  '#2e9ceb', // blue
  '#959595', // gray
  '#ffffff', // white
];

export const ERASER_CURSOR_COLOR = '#888';
export const ERASER_SIZE = 20;
export const ERASER_MIN_SIZE = 10;
export const ERASER_MAX_SIZE = 200;
export const ERASER_SCALE_FACTOR = 5;
export const DEFAULT_STROKE_COLOR_LIGHTMODE = '#000000';
export const DEFAULT_STROKE_COLOR_DARKMODE = '#ffffff';
export const CANVAS_BACKGROUND_COLOR_LIGHTMODE = '#f8f8f8';
export const CANVAS_BACKGROUND_COLOR_DARKMODE = '#252525';

export const MIN_SCALE = 0.05; // 5%
export const MAX_SCALE = 10; // 1000%
export const SCALE_FACTOR = 0.002; // 0.2%
export const SCALE_BY = 0.1; // 10%
